import React from "react";
import Dashboard from "components/dashboard";
import { PageSection, PageHeaderBar } from "components/page";
import { useMutation } from "@apollo/react-hooks";
import DataGrid from "components/data-grid";
import ValidatedForm from "components/form";
import { mutation, validationSchema, defaultValues, handleSubmit, NewContractForm } from "./forms/new-form";
import { useCurrentCustomerContext } from "components/current-customer-context";

const ContractNewPage = ({ intl, history }) => {
  const [createContract] = useMutation(mutation);
  const { currentCustomerId } = useCurrentCustomerContext();

    return (
    <Dashboard>
      <PageHeaderBar title="app.page.contract.new" />
      <PageSection>
        <ValidatedForm
          initialValues={defaultValues}
          validationSchema={validationSchema(intl)}
          onSubmit={handleSubmit({
            createContract,
            history,
            customerId: currentCustomerId,
          })}
        >
          {props => (
            <DataGrid>
              <NewContractForm {...props}/>
            </DataGrid>
          )}
        </ValidatedForm>
      </PageSection>
    </Dashboard>
  );
};

export default ContractNewPage;
